import { CustomError } from "./custom.error";

export class HttpError extends CustomError {
	public readonly body: any;
	public readonly request: any;
	public readonly response: Response;
	public readonly status: number;
	public readonly name = "HttpError";

	public constructor(message: string, statusCode: number, body?: any, request?: any, response?: Response) {
		super(message);

		this.status = statusCode;
		this.request = request;
		this.response = response;
		this.body = body;
	}

	public getExtras(): Record<string, any> {
		return {
			state: this.status,
			response: this.body,
			url: this.response.url,
		};
	}
}
